import script from "./WCAddToCartModernCardButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCAddToCartModernCardButton.vue?vue&type=script&setup=true&lang=ts"

import "./WCAddToCartModernCardButton.vue?vue&type=style&index=0&id=71c45f1f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c45f1f"]])

export default __exports__